var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75765 6C6.566 6 6.3656 6.06446 6.21934 6.2106C5.92689 6.50364 5.92689 6.99528 6.21934 7.28832L10.9234 11.9957L6.21934 16.7031C5.92689 16.9961 5.92689 17.4877 6.21934 17.7808C6.51186 18.0731 7.00344 18.0731 7.29596 17.7808L12 13.0734L16.704 17.7808C16.9966 18.0731 17.4881 18.0731 17.7807 17.7808C18.0731 17.4877 18.0731 16.9961 17.7807 16.7031L13.0766 11.9957L17.7807 7.28832C18.0731 6.99528 18.0731 6.50364 17.7807 6.2106C17.6344 6.06446 17.4339 6 17.2423 6C17.0507 6 16.8504 6.06446 16.704 6.2106L12 10.918L7.29596 6.2106C7.1497 6.06446 6.9493 6 6.75765 6Z",
    fill: "#DC362E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.c0b2e86c07bf0a1ae6035956546e93c9.svg";
export { ForwardRef as ReactComponent };